import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errorText } from "@/lib/api";
import { Grid, Section } from "@/components/admin/SettingsFields";
import PlayersSection from "@/components/admin/PlayersSection";

const GENERAL = [
  ["server_name", "Nazwa serwera", "text"],
  ["game_ip", "IP serwera gry (status)", "text"],
  ["game_port", "Port (np. 13000 / 11002)", "number"],
  ["client_exe", "Plik gry", "text"],
  ["config_exe", "Plik konfiguracji", "text"],
  ["website_url", "Strona WWW / forum", "text"],
  ["discord_url", "Discord (link zaproszenia)", "text"],
];
const WEBSITE = [
  ["download_url", "Link do pobrania klienta", "text"],
  ["download_mirror_url", "Link mirror (opcjonalnie)", "text"],
  ["client_size", "Rozmiar klienta (np. 1.2 GB)", "text"],
];
const MYSQL = [
  ["mysql_host", "Host MySQL", "text"],
  ["mysql_port", "Port MySQL", "number"],
  ["mysql_user", "Użytkownik", "text"],
  ["mysql_password", "Hasło", "password"],
  ["account_db", "Baza kont", "text"],
  ["player_db", "Baza postaci", "text"],
];

export default function SettingsForm() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/settings").then((r) => setS(r.data)); }, []);
  if (!s) return null;

  const save = async (e) => {
    e.preventDefault();
    try {
      await api.put("/settings", { ...s, game_port: Number(s.game_port), mysql_port: Number(s.mysql_port) });
      toast.success("Zapisano ustawienia");
    } catch (err) { toast.error(errorText(err)); }
  };

  return (
    <form onSubmit={save} className="max-w-2xl space-y-12" data-testid="settings-form">
      <Section title="Ustawienia serwera"><Grid fields={GENERAL} s={s} set={setS} /></Section>
      <Section title="Strona WWW">
        <Grid fields={WEBSITE} s={s} set={setS} />
        <label className="flex items-center gap-3 cursor-pointer" data-testid="settings-registration-toggle">
          <input type="checkbox" checked={!!s.registration_enabled} onChange={(e) => setS({ ...s, registration_enabled: e.target.checked })} className="w-4 h-4 accent-amber-500" />
          <span className="text-sm text-slate-300">Rejestracja kont włączona <span className="text-slate-600">(wymaga bazy MySQL poniżej)</span></span>
        </label>
      </Section>
      <Section title="Baza danych gry (MySQL)">
        <Grid fields={MYSQL} s={s} set={setS} />
        <p className="text-xs text-slate-600">Używana do rankingu, rejestracji i liczby graczy. Utwórz osobnego użytkownika MySQL: SELECT na bazie postaci oraz SELECT, INSERT na tabeli account.account.</p>
      </Section>
      <PlayersSection s={s} set={setS} />
      <button className="px-6 py-2 bg-amber-500 text-white font-bold rounded hover:bg-amber-400 transition-colors text-sm" data-testid="settings-save-btn">Zapisz</button>
    </form>
  );
}
